import { QueryBuilderTokenType } from '../../../../types';
import { getInputContext } from '../getInputContext';

export const canCloseBracket = (tokens: QueryBuilderTokenType[]): boolean => {
  if (getInputContext(tokens) !== 'expectOperatorOrClose') {
    return false;
  }

  let openBracketIndex = -1;
  let depth = 0;

  for (let index = 0; index < tokens.length; index += 1) {
    const token = tokens[index];

    if (token.type === 'bracket' && token.bracket === 'OPEN') {
      depth += 1;
      openBracketIndex = index;
    }

    if (token.type === 'bracket' && token.bracket === 'CLOSE') {
      depth -= 1;
    }
  }

  if (depth <= 0 || openBracketIndex === -1) {
    return false;
  }

  return tokens
    .slice(openBracketIndex + 1)
    .some((token) => token.type === 'entityValue');
};
